import axios from "axios";
import API from "@aws-amplify/api";

import store from "../Redux/store";
import { Auth } from "aws-amplify";
import ApiCalendar from "react-google-calendar-api";

let headers = null;
function updateToken() {
  const state = store.getState();
  try {
    const token = state.user.idToken.jwtToken;
    headers = {
      Authorization: token,
      "Content-Type": "application/json",
    };
  } catch (e) {
    console.log("user or token does not exist");
  }
}
store?.subscribe(updateToken);
const getHeaders = async () => {
  return await getGoogleHeaders();
  // return {
  //   Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
  //   "Content-Type": "application/json",
  // };
};
const getGoogleHeaders = async () => {
  return {
    Authorization: (await ApiCalendar.gapi.auth.getToken())?.id_token,
    "Content-Type": "application/json",
  };
};
export const appLoad = async () => {
  console.log("app loading");
  return await API.get("GeneralEndpoint", "/");
};
//course schedule
export const updateTask = async (task) => {
  //also for adding task
  console.log("Sending update task", task);
  const resp = await API.put("GeneralEndpoint", "/tasks", {
    body: task,
  });
  console.log("RETURNED", resp);
};
export const deleteTask = async (id) => {
  console.log("deleting", id);
  const resp = await API.del("GeneralEndpoint", "/tasks", {
    body: { id },
  });
};
export const setCourses = async (courses) => {
  console.log("Sending update courses", courses);
  return await API.put("GeneralEndpoint", "/courses", {
    body: courses,
  });
};

export const updateEvent = async (event) => {
  //also for adding events
  return await API.put("GeneralEndpoint", "/events", {
    body: event,
  });
};

export const removeEvent = async (id) => {
  return await API.del("GeneralEndpoint", "/events", {
    body: { id },
  });
};

export const setLinks = async (links) => {
  return await API.put("GeneralEndpoint", "/links", {
    body: links,
  });
};
export const setTimeslots = async (timeslots) => {
  return await API.put("GeneralEndpoint", "/scheduled", {
    body: { scheduled: timeslots },
  });
};
export const setScheduled = async (scheduled) => {
  return await API.put("GeneralEndpoint", "/newscheduled", {
    body: { scheduled: scheduled },
  });
};
//food planing

//daily routine
